import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import { FaEnvelope } from 'react-icons/fa'
import { EmailProposalModalContainer } from './EmailProposalModalContainer'
import { FollowupDateModal } from 'components/common/modals/FollowupDateModal'
import s from '../SidebarButtons.scss'
import cn from 'classnames'
import * as ACT from 'components/proposals/Proposal/actions'

const EmailClientBtn = ({ proposal, changeProperty }) => {
  const [showEmailProposalModal, setShowEmailProposalModal] = useState(false)
  const [showProposalFollowup, setShowProposalFollowup] = useState(proposal.showProposalFollowup)

  useEffect(() => {
    setShowProposalFollowup(proposal.showProposalFollowup)
  }, [proposal, proposal.showProposalFollowup])

  const dispatch = useDispatch()

  const toggleEmailProposalModal = () => setShowEmailProposalModal(!showEmailProposalModal)

  const toggleFollowupDateModal = () => {
    dispatch({
      type: ACT.SHOW_PROPOSAL_FOLLOWUP,
      payload: {
        showProposalFollowup: !proposal.showProposalFollowup
      }
    })
  }

  const onSave = followUpDate => changeProperty(followUpDate, 'followUpDate')

  return (
    <>
      <Button className={cn(s.sidebarButton, s.emailButton)} onClick={toggleEmailProposalModal}>
        <FaEnvelope style={{ position: 'relative', bottom: 2, right: 4 }} />
        Email Proposal to Client
      </Button>
      <EmailProposalModalContainer
        toggleEmailProposalModal={toggleEmailProposalModal}
        showEmailProposalModal={showEmailProposalModal}
        proposal={proposal}
      />
      <FollowupDateModal
        entity={proposal}
        onSave={onSave}
        showFollowupDateModal={showProposalFollowup}
        toggleFollowupDateModal={toggleFollowupDateModal}
        title="Proposal"
        cancelCb={() => setShowProposalFollowup(false)}
      />
    </>
  )
}

export default EmailClientBtn
